import { Component, HostListener, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IArea, IBoothColors, IVideoAreaSettings } from '@sv/interfaces';
import { AreaAnalyticsService } from 'src/app/_services/_analytics/area-analytics.service';
import { TicketcodeAuthService } from 'src/app/_services/_auth/ticketcode-auth.service';

@Component({
  selector: 'app-video-area',
  templateUrl: './video-area.component.html',
  styleUrls: ['./video-area.component.scss']
})
export class VideoAreaComponent implements OnInit, OnDestroy {
  settings: IVideoAreaSettings;
  videoPlaying: number;
  primaryColor: string;
  secondaryColor: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { area: IArea; settings: IVideoAreaSettings; colors: IBoothColors },
    private dialogRef: MatDialogRef<VideoAreaComponent>,
    private areaAnalyticsService: AreaAnalyticsService,
    private authService: TicketcodeAuthService
  ) {}

  mobile = false;

  @HostListener('window:resize', [])
  onResize() {
    const width = window.innerWidth;
    this.mobile = width < 699;
  }

  ngOnInit(): void {
    this.mobile = document.documentElement.clientWidth < 699;
    if (!this.data) {
      this.dialogRef.close();
    } else {
      this.settings = this.data.settings;
      if (this.data.colors) {
        this.primaryColor = this.data.colors.areaPrimary ?? '#92d050';
        this.secondaryColor = this.data.colors.areaSecondary ?? 'white';
      } else {
        this.primaryColor = '#92d050';
        this.secondaryColor = 'white';
      }
    }
  }

  enlargeVideo(event, videoIndex) {
    this.videoPlaying = videoIndex;
    event.target.parentElement.parentElement.className = 'playing';
  }

  shrinkVideo(event) {
    this.videoPlaying = undefined;
    const videos = document.getElementsByClassName('video');
    // tslint:disable-next-line:prefer-for-of
    for (let index = 0; index < videos.length; index++) {
      const element: any = videos[index];
      element.pause();
    }
    event.target.parentElement.className = 'video-container';
  }

  ngOnDestroy() {
    const url = window.location.href;
    if (!url.includes('cloudfront.net')) {
      if (localStorage.getItem('dataUsage') === 'true') {
        // this.areaAnalyticsService.newAreaView(this.data.area, this.authService.decodeToken()._id);
      } else {
        this.areaAnalyticsService.newAreaView(this.data.area);
      }
    }
  }
}
